'use client';

import { c as _c } from "react/compiler-runtime";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';
import { toast } from '@/components/ui/toast';
function createQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: error => {
        toast.add({
          type: 'error',
          title: error.message
        });
      }
    }),
    mutationCache: new MutationCache({
      onError: error => {
        toast.add({
          type: 'error',
          title: error.message
        });
      }
    })
  });
}
type QueryProviderProps = {
  children: React.ReactNode;
};
export function QueryProvider(props) {
  const $ = _c(4);
  const {
    children
  } = props;
  const [queryClient] = useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ReactQueryDevtools />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children || $[2] !== queryClient) {
    t1 = <QueryClientProvider client={queryClient}>{children}{t0}</QueryClientProvider>;
    $[1] = children;
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp() {
  return createQueryClient();
}